"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PriceFormatArgs = void 0;
const i18n_args_1 = require("./i18n-args");
class PriceFormatArgs extends i18n_args_1.I18nArgs {
    constructor(_locale, _currency, _cxFamily, _cxId, _cxProgram, _priceFormatType) {
        super();
        this._locale = _locale;
        this._currency = _currency;
        this._cxFamily = _cxFamily;
        this._cxId = _cxId;
        this._cxProgram = _cxProgram;
        this._priceFormatType = _priceFormatType;
    }
    get locale() {
        return this._locale;
    }
    get currency() {
        return this._currency;
    }
    get cxFamily() {
        return this._cxFamily;
    }
    get cxId() {
        return this._cxId;
    }
    get cxProgram() {
        return this._cxProgram;
    }
    get priceFormatType() {
        return this._priceFormatType;
    }
}
exports.PriceFormatArgs = PriceFormatArgs;
//# sourceMappingURL=price-format-args.js.map